import 'd3';
import 'nvd3/build/nv.d3';
import 'angular-nvd3';

const SparkLineComponent = {
  restrict: 'E',
  template: require('./spark-line.html'),
  bindings: {
    sparkLine: '<',
    id: '<',
    color: '@',
    height: '@',
    width: '@',
    pointsToShow: '@?'
  },
  controllerAs: 'vm',
  controller: SparkLineController
};

function SparkLineController() {
  var vm = this;
  var colorArray = [
    '#67b7dc',
    '#fdd400',
    '#84b761',
    '#cc4748',
    '#cd82ad',
    '#2f4074',
    '#448e4d',
    '#b7b83f',
    '#b9783f',
    '#b93e3d',
    '#913167',
    '#666',
    '#777'
  ];
  var defaultPointsToShow = 20;
  vm.chartData = [];
  vm.chartOptions = {
    chart: {
      type: 'sparkline',
      x: function (d) {
        return d.x;
      },
      y: function (d) {
        return d.y;
      },
      useInteractiveGuideline: true,
      duration: 0,
      height: 50,
      width: 100,
      showMinMaxPoints: false,
      showCurrentPoint: false,
      sparkline: {
        css: {
          'stroke-width': '5px'
        }
      },
      xAxis: {
        height: 50
      },
      yAxis: {
        width: 100
      },
      style: {
        fill: 'none'
      }
    }
  };
  var chartColor;

  vm.$onInit = function () {
    chartColor = vm.color;

    if (!chartColor) {
      var currColorIndex = Math.floor(Math.random() * (colorArray.length - 1 + 1));
      chartColor = colorArray[currColorIndex];
    }
    vm.chartOptions.chart.color = function () {
      return chartColor;
    };

    if (vm.height) {
      vm.chartOptions.chart.height = vm.height;
      vm.chartOptions.chart.xAxis.height = vm.height;
    }

    if (vm.width) {
      vm.chartOptions.chart.width = vm.width;
      vm.chartOptions.chart.yAxis.width = vm.width;
    }

    vm.pointsToShow = vm.pointsToShow || defaultPointsToShow;
  };

  vm.$onChanges = function (changes) {
    if (changes.sparkLine && changes.sparkLine.currentValue) {
      var mapped = _.map(changes.sparkLine.currentValue, function (item) {
        return {
          x: new Date(item.t).getTime(),
          y: item.v
        };
      });

      var unique = _.unique(mapped);
      var last = _.takeRight(unique, vm.pointsToShow);
      vm.chartData = last;
    }
  };
}

export default SparkLineComponent;